import { AddIcon, Flex, Text } from "@fluentui/react-northstar";
import React from "react";
import styled from "styled-components";
import { CheckmarkStarburstFilled } from "@fluentui/react-icons";
import {
    render_badge_action_document,
    render_badge_action_document_by_id,
} from "../../../../constants/tasks";

export const OffBoardingArchivedActions = ({ ArchivedUser }) => {
    return (
        <Content column>
            <Flex
                styles={{ marginBottom: "14px" }}
                gap="gap.small"
                vAlign="center"
            >
                <CheckmarkStarburstFilled
                    style={{ color: "green", width: "24px", height: "24px" }}
                />
                <TitleText content={"Actions effectuées en Offboarding"} />
            </Flex>
            <Flex fill column gap="gap.small">
                {ArchivedUser?.offboarding_tasks_done?.length === 0 ? (
                    <Flex vAlign="center" hAlign="center" fill>
                        <EmptyOffboardingArchivedTask content="Pas de tâches offboarding à effectuer " />
                    </Flex>
                ) : (
                    ArchivedUser?.offboarding_tasks_done?.map((action) => {
                        return (
                            <Card
                                vAlign="center"
                                hAlign="center"
                                fill
                                space="between"
                            >
                                <Flex vAlign="center" gap="gap.small">
                                    <CheckmarkStarburstFilled
                                        style={{
                                            color: "green",
                                            width: "24px",
                                            height: "24px",
                                        }}
                                    />
                                    <TitleCard content={action?.name} />
                                </Flex>
                                <BadgeAction vAlign="center">
                                    {/* <CheckmarkStarburstFilled />
                                    <Text content={"Signature"} /> */}
                                </BadgeAction>
                                {render_badge_action_document_by_id(
                                    action?.document_action
                                )}
                            </Card>
                        );
                    })
                )}
            </Flex>
        </Content>
    );
};

const EmptyOffboardingArchivedTask = styled(Text)`
    color: #616161;
    text-align: center;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
    margin-top: 24px;
`;

const Content = styled(Flex)`
    padding: 24px 16px;
    background-color: #f5f5f5;
    width: 447px;
    height: 254px;
`;
const TitleText = styled(Text)`
    color: #424242;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
`;

const Card = styled(Flex)`
    width: 400px;
    height: 48px;
    padding: 0px 16px;
    border-radius: 8px;
    background: #fff;
    box-shadow: 0px 0.3px 0.9px 0px rgba(0, 0, 0, 0.07),
        0px 1.6px 3.6px 0px rgba(0, 0, 0, 0.11);
`;

const TitleCard = styled(Text)`
    overflow: hidden;
    color: #242424;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
`;

const BadgeAction = styled(Flex)`
    background-color: #f5f5f5;
    padding: 4px 8px;
    border-radius: 4px;
    gap: 4px;
`;
